module.exports = __webpack_public_path__ + "static/media/tulus-logo.e7e5b72e.svg";